module.exports = __webpack_public_path__ + "img/25.ca7dd129.png";